import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { loadScript } from "../lib/script";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const LIVE_PAYPAL_CLIENT_ID = "BAALt2wMjypClJgdZ7xjUd98mDJHuAuHOv1a4Ctc8URMi7URay-vxRWLRVjvLrbZyC00lT7_RZAWrifarc";

export function PayPalCheckout({ planId }: { planId: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { user, refresh } = useAuth();
  const isProductionHost = window.location.hostname === "sonicfiveelements.com" ||
    window.location.hostname === "www.sonicfiveelements.com";
  const clientId = isProductionHost ? LIVE_PAYPAL_CLIENT_ID : import.meta.env.VITE_PAYPAL_CLIENT_ID;
  useEffect(() => {
    if (!user || !clientId || !ref.current) return;
    let buttons: PayPalButtons | undefined;
    let active = true;
    const src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(clientId)}&currency=USD&intent=capture&commit=true&locale=en_US`;
    void loadScript(src).then(async () => {
      if (!active || !ref.current || !window.paypal) return;
      buttons = window.paypal.Buttons({
        style: { shape: "pill", label: "pay", height: 42 },
        createOrder: async () => {
          void api.track("paypal_checkout_started", { planId });
          return (await api.createPayPalOrder(planId)).orderId;
        },
        onApprove: async (data: { orderID: string }) => {
          const result = await api.capturePayPalOrder(data.orderID);
          await refresh();
          setSuccess(`Payment complete. ${result.creditsAdded || 0} credits were added to your account.`);
        },
        onError: (reason: Error) => setError(reason.message || "PayPal checkout failed.")
      });
      await buttons.render(ref.current);
    }).catch((reason: Error) => setError(reason.message));
    return () => { active = false; buttons?.close(); };
  }, [clientId, planId, refresh, user]);
  if (!user) return <Link className="button secondary full" to="/account">Sign in to buy</Link>;
  if (!clientId) return <div className="config-note">PayPal configuration required.</div>;
  return <><div ref={ref} className="paypal-slot" />{success && <p className="form-success">{success}</p>}{error && <p className="form-error">{error}</p>}</>;
}
